// Get the kentico pagination elements that are arrows and hide them

let listingPagination = document.querySelector('.listing-pagination')
if(listingPagination){
  let pageBtns = listingPagination.getElementsByTagName('a')

  let icon = listingPagination.getElementsByTagName('i')

  var arrPageBtns = [];
  for(var i = pageBtns.length; i--; arrPageBtns.unshift(pageBtns[i]));

  let pageBtnsWithArrows = arrPageBtns.forEach(function(pageBtn) {

      let span = pageBtn.querySelector('.sr-only') != null
      if (span) {
          pageBtn.classList.add('hide')
      }
  })
}



// WEBPACK FOOTER //
// ./CMS/NationalGuild/src/js/components/pagination.js